import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import { Dropdown } from 'primereact/dropdown';

function AddPackege() {
  const navigate = useNavigate();
  const [venues, setVenues] = useState([]);
  const [error, setError] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    centerContent: {},
    featuredImage: null,
    galleryImages: null,
    centerContentImage: null,
    bookingInfoImage: null,
    bookingDescription: '',
    bookingLink: '',
    attributeBestFor: '',
    attributeBestSeason: '',
    topVenues: '',
    isFeatured: false,
    topText: '',
    leftText: '',
    rightText: ''
  });

  const [featuredPreview, setFeaturedPreview] = useState('');
  const [galleryPreviews, setGalleryPreviews] = useState([]);
  const [centerContentPreview, setCenterContentPreview] = useState('');
  const [bookingPreview, setBookingPreview] = useState('');

  const [selectedTopVenues, setSelectedTopVenues] = useState([]);
  const [plans, setPlans] = useState([{ title: '', description: '', others: [] }]);
  const [additionalDetails, setAdditionalDetails] = useState([{ text: '', details: [] }]);

  const handleInputChange = (e) => {
    const { name, value, files, type, checked } = e;
    if (files) {
      if (name === 'featuredImage') {
        const file = files[0];
        setFeaturedPreview(file ? URL.createObjectURL(file) : '');
      }
      if (name === 'galleryImages') {
        const previews = Array.from(files).map(f => URL.createObjectURL(f));
        setGalleryPreviews(previews);
      }
      if (name === 'centerContentImage') {
        const file = files[0];
        setCenterContentPreview(file ? URL.createObjectURL(file) : '');
      }
      if (name === 'bookingInfoImage') {
        const file = files[0];
        setBookingPreview(file ? URL.createObjectURL(file) : '');
      }
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: files ? files : (type === 'checkbox' ? checked : value)
    }));
  };

  const handleImageUpload = async (image) => {
    const formData = new FormData();
    formData.append('image', image);

    try {
      const response = await axios.post(`${config.BASE_URL}/api/admin/upload-packege-image`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data?.image;
    } catch (error) {
      console.error('Image upload failed:', error);
      return null;
    }
  };

  useEffect(() => {
    const fetchVenues = async () => {
      try {
        const response = await axios.get(`${config.BASE_URL}/api/admin/get-venues`, { withCredentials: true });
        if (response.data) {
          setVenues(response.data);
        }
      } catch (err) {
        console.log('Failed to fetch venues');
      }
    };
    fetchVenues();
  }, []);

  // Plans handlers
  const addPlan = () => setPlans(prev => [...prev, { title: '', description: '', others: [] }]);
  const removePlan = (index) => setPlans(prev => prev.filter((_, i) => i !== index));
  const handlePlanChange = (index, field, value) => {
    setPlans(prev => prev.map((p, i) => (i === index ? { ...p, [field]: value } : p)));
  };
  const addPlanOther = (planIndex) => {
    setPlans(prev => prev.map((p, i) => (i === planIndex ? { ...p, others: [...p.others, { image: '', text: '' }] } : p)));
  };
  const removePlanOther = (planIndex, otherIndex) => {
    setPlans(prev => prev.map((p, i) => (i === planIndex ? { ...p, others: p.others.filter((_, oi) => oi !== otherIndex) } : p)));
  };
  const handlePlanOtherChange = (planIndex, otherIndex, field, value) => {
    setPlans(prev => prev.map((p, i) => {
      if (i !== planIndex) return p;
      return { ...p, others: p.others.map((o, oi) => (oi === otherIndex ? { ...o, [field]: value } : o)) };
    }));
  };

  // Additional details handlers
  const addAdditionalSection = () => setAdditionalDetails(prev => [...prev, { text: '', details: [] }]);
  const removeAdditionalSection = (index) => setAdditionalDetails(prev => prev.filter((_, i) => i !== index));
  const handleAdditionalSectionChange = (index, value) => {
    setAdditionalDetails(prev => prev.map((s, i) => (i === index ? { ...s, text: value } : s)));
  };
  const addAdditionalDetail = (sectionIndex) => {
    setAdditionalDetails(prev => prev.map((s, i) => (i === sectionIndex ? { ...s, details: [...s.details, { image: '', description: '' }] } : s)));
  };
  const removeAdditionalDetail = (sectionIndex, detailIndex) => {
    setAdditionalDetails(prev => prev.map((s, i) => (i === sectionIndex ? { ...s, details: s.details.filter((_, di) => di !== detailIndex) } : s)));
  };
  const handleAdditionalDetailChange = (sectionIndex, detailIndex, field, value) => {
    setAdditionalDetails(prev => prev.map((s, i) => {
      if (i !== sectionIndex) return s;
      return { ...s, details: s.details.map((d, di) => (di === detailIndex ? { ...d, [field]: value } : d)) };
    }));
  };

  const handleAddLocation = async (e) => {
    e.preventDefault();
    setError(null);
    setSubmitLoading(true);

    try {
      // Basic client-side validations to match backend schema
      if (!formData.featuredImage || formData.featuredImage.length === 0) {
        setError('Featured image is required.');
        setSubmitLoading(false);
        return;
      }
      if (!formData.centerContentImage || formData.centerContentImage.length === 0) {
        setError('Center content image is required.');
        setSubmitLoading(false);
        return;
      }
      // if (!formData.galleryImages || formData.galleryImages.length === 0) {
      //   setError('At least one gallery image is required.');
      //   return;
      // }

      // Prepare filtered payloads
      const filteredPlans = (plans || [])
        .filter(p => (p?.title || '').trim() !== '')
        .map(p => ({
          title: p.title,
          description: (p.description || '').trim(),
          others: (p.others || []).filter(o => (o?.text || '').trim() !== '' || (o?.image || '').trim() !== '')
        }));

      const filteredAdditionalDetails = (additionalDetails || [])
        .filter(s => (s?.text || '').trim() !== '' || (s?.details || []).some(d => (d?.description || '').trim() !== '' || (d?.image || '').trim() !== ''))
        .map(s => ({
          text: s.text,
          details: (s.details || []).filter(d => (d?.description || '').trim() !== '' || (d?.image || '').trim() !== '')
        }));

      const data = new FormData();
      data.append('title', formData.title);
      data.append('description', formData.description || '');
      data.append('centerContent', JSON.stringify({ topText: formData.topText, leftText: formData.leftText, rightText: formData.rightText }));
      const bestFor = (formData.attributeBestFor || '').split(',').map(s => s.trim()).filter(Boolean);
      const bestSeason = (formData.attributeBestSeason || '').split(',').map(s => s.trim()).filter(Boolean);
      const topVenues = selectedTopVenues;
      data.append('attributeBestFor', JSON.stringify(bestFor));
      data.append('attributeBestSeason', JSON.stringify(bestSeason));
      data.append('topVenues', JSON.stringify(topVenues));
      data.append('plans', JSON.stringify(filteredPlans));
      data.append('additionalDetails', JSON.stringify(filteredAdditionalDetails));
      const bookingInfo = { description: formData.bookingDescription || '', link: formData.bookingLink || '' };
      data.append('bookingInfo', JSON.stringify(bookingInfo));
      data.append('isFeatured', formData.isFeatured);

      // if (formData.galleryImages) {
      //   for (let i = 0; i < formData.galleryImages.length; i++) {
      //     data.append('galleryImages', formData.galleryImages[i]);
      //   }
      // }

      if (formData.featuredImage) {
        data.append('featuredImage', formData.featuredImage[0]);
      }
      if (formData.centerContentImage) {
        data.append('centerContentImage', formData.centerContentImage[0]);
      }
      if (formData.bookingInfoImage) {
        data.append('bookingInfoImage', formData.bookingInfoImage[0]);
      }

      const response = await axios.post(`${config.BASE_URL}/api/admin/add-packege`, data, {
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.status === 200) {
        const token = localStorage.getItem('token');
        if (token) {
          navigate('/admin/packages');
        } else {
          navigate('/admin/login');
        }
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to add Packege');
    } finally {
      setSubmitLoading(false);
    }
  };

  console.log("formData: ", formData);

  return (
    <div className="dashboard">
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <div className="container">
        <h1 className="dash_title">Dashboard</h1>
        <div className="main-section">
          <div className="back_btn_wrap">
            <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
          </div>
          <div className="main-inner add_project_main">
            <form onSubmit={handleAddLocation} encType="multipart/form-data">
              <div className="form-login bg-gray-rounded">

                <div className="add_field titleField">
                  <h2>Packege Title</h2>
                  <input
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={(e) => handleInputChange(e.target)}
                    required
                  />
                </div>

                <div className="add_field textareaField">
                  <h2>Description</h2>
                  <textarea
                    name="description"
                    value={formData.description}
                    onChange={(e) => handleInputChange(e.target)}
                  />
                </div>

                <div className="add_field titleField">
                  <h2>Featured Image</h2>
                  <div className="form-group">
                    <div className="file-upload">
                      <input
                        type="file"
                        className="form-control"
                        name="featuredImage"
                        onChange={(e) => handleInputChange(e.target)}
                        required
                      />
                      <i className="fa fa-camera i-pic-upload"></i>
                    </div>
                  </div>
                  {featuredPreview && (
                    <div className="image-preview">
                      <img src={featuredPreview} alt="Featured preview" style={{ maxWidth: '200px' }} />
                    </div>
                  )}
                </div>

                {/* <div className="add_field titleField">
                  <h2>Gallery Images</h2>
                  <div className="form-group">
                    <div className="file-upload">
                      <input
                        type="file"
                        className="form-control"
                        name="galleryImages"
                        multiple
                        onChange={(e) => handleInputChange(e.target)}
                        // required
                      />
                      <i className="fa fa-camera i-pic-upload"></i>
                    </div>
                  </div>
                  {galleryPreviews?.length > 0 && (
                    <div className="image-preview-list" style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                      {galleryPreviews.map((src, idx) => (
                        <img key={idx} src={src} alt={`Gallery ${idx}`} style={{ width: 100, height: 100, objectFit: 'cover' }} />
                      ))}
                    </div>
                  )}
                </div> */}

                <div className="add_field titleField">
                  <h2>Best For (comma separated)</h2>
                  <input
                    type="text"
                    name="attributeBestFor"
                    value={formData.attributeBestFor}
                    onChange={(e) => handleInputChange(e.target)}
                  />
                </div>

                <div className="add_field titleField">
                  <h2>Best Season (comma separated)</h2>
                  <input
                    type="text"
                    name="attributeBestSeason"
                    value={formData.attributeBestSeason}
                    onChange={(e) => handleInputChange(e.target)}
                  />
                </div>
              </div>
              {/* <div className="form-login bg-gray-rounded">
                <div className="add_field titleField">
                  <h2>Top Venues</h2>
                  <select
                    multiple
                    value={selectedTopVenues}
                    onChange={(e) => {
                      const options = Array.from(e.target.selectedOptions).map(o => o.value);
                      setSelectedTopVenues(options);
                    }}
                  >
                    {venues.map((v) => (
                      <option key={v._id} value={v._id}>{v.title}</option>
                    ))}
                  </select>
                </div>
              </div> */}
              <div className="form-login bg-gray-rounded">
                <div className="add_field textareaField">
                  <h1>Center Content</h1>
                  <div className="contentFields">
                    <div className="add_field titleField">
                      <h2>Image</h2>
                      <div className="form-group">
                        <div className="file-upload">
                          <input
                            type="file"
                            className="form-control"
                            name="centerContentImage"
                            onChange={(e) => handleInputChange(e.target)}
                          // required
                          />
                          <i className="fa fa-camera i-pic-upload"></i>
                        </div>
                      </div>
                      {centerContentPreview && (
                        <div className="image-preview">
                          <img src={centerContentPreview} alt="Center content preview" style={{ maxWidth: '200px' }} />
                        </div>
                      )}
                    </div>

                    {/* <div className="add_field titleField">
                      <h2>Top Text</h2>
                      <input
                        type="text"
                        name="topText"
                        value={formData.topText}
                        onChange={(e) => handleInputChange(e.target)}
                        required
                      />
                    </div> */}

                    <div className="add_field titleField">
                      <h2>Left Text</h2>
                      <input
                        type="text"
                        name="leftText"
                        value={formData.leftText}
                        onChange={(e) => handleInputChange(e.target)}
                      // required
                      />
                    </div>

                    <div className="add_field titleField">
                      <h2>Right Text</h2>
                      <input
                        type="text"
                        name="rightText"
                        value={formData.rightText}
                        onChange={(e) => handleInputChange(e.target)}
                      // required
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-login bg-gray-rounded">
                <div className="add_field itineraryFields">
                  <h1>Plans     <button type="button" onClick={addPlan}>Add NewPlan</button>
                  </h1>
                  {plans.map((plan, pi) => (
                    <>
                      <h2>{pi + 1}. Plan    <button type="button" onClick={() => removePlan(pi)}>Remove Plan</button>
                      </h2>
                      <div key={pi} className="addItineraryFields">

                        <div className="add_field titleField">
                          <h2>Title</h2>
                          <input
                            type="text"
                            value={plan.title}
                            onChange={(e) => handlePlanChange(pi, 'title', e.target.value)}
                          />
                        </div>
                        <div className="add_field titleField">
                          <h2>Description</h2>
                          <input
                            type="text"
                            value={plan.description}
                            onChange={(e) => handlePlanChange(pi, 'description', e.target.value)}
                          />
                        </div>

                      </div>
                      <div>
                        <div className="add_field titleField">
                          <h2>Others</h2>
                          {plan.others.map((other, oi) => (
                            <div key={oi} className="addItineraryFields">
                              <div className="add_field titleField">
                                <h3>Text</h3>
                                <input
                                  type="text"
                                  value={other.text}
                                  onChange={(e) => handlePlanOtherChange(pi, oi, 'text', e.target.value)}
                                />
                              </div>
                              <div className="add_field titleField">
                                <h3>Image</h3>
                                <div className="form-group">
                                  <div className="file-upload">
                                    <input
                                      type="file"
                                      className="form-control"
                                      onChange={async (e) => {
                                        const file = e.target.files && e.target.files[0];
                                        if (file) {
                                          const url = await handleImageUpload(file);
                                          if (url) handlePlanOtherChange(pi, oi, 'image', url);
                                        }
                                      }}
                                    />
                                    <i className="fa fa-camera i-pic-upload"></i>
                                  </div>
                                </div>
                                {other.image && <small>{other.image}</small>}
                                {other.image && (
                                  <div className="image-preview">
                                    <img src={`${config.BASE_URL}${other.image}`} alt="Plan other" style={{ maxWidth: '200px' }} />
                                  </div>
                                )}
                              </div>
                              <button type="button" onClick={() => removePlanOther(pi, oi)}>Remove Item</button>
                            </div>
                          ))}
                          <button type="button" onClick={() => addPlanOther(pi)}>Add Other</button>
                        </div>
                      </div>
                      <hr />
                    </>
                  ))}
                </div>
              </div>
              <div className="form-login bg-gray-rounded">
                <div className="add_field itineraryFields">
                  <h1>Additional Details</h1>
                  {additionalDetails.map((section, si) => (
                    <>
                      <div key={si} className="addItineraryFields">
                        <div className="add_field titleField">
                          <h2>Section Title</h2>
                          <input
                            type="text"
                            value={section.text}
                            onChange={(e) => handleAdditionalSectionChange(si, e.target.value)}
                          />
                        </div>
                      </div>
                      <div>
                        <div className="add_field titleField">
                          <h2>Items</h2>
                          {section.details.map((detail, di) => (
                            <>
                              <h2>{di + 1}. Item</h2>
                              <div key={di} className="addItineraryFields">
                                <div className="add_field titleField">
                                  <h3>Title</h3>
                                  <input
                                    type="text"
                                    value={detail.description}
                                    onChange={(e) => handleAdditionalDetailChange(si, di, 'description', e.target.value)}
                                  />
                                </div>
                                <div className="add_field titleField">
                                  <h3>Image</h3>
                                  <div className="form-group">
                                    <div className="file-upload">
                                      <input
                                        type="file"
                                        className="form-control"
                                        onChange={async (e) => {
                                          const file = e.target.files && e.target.files[0];
                                          if (file) {
                                            const url = await handleImageUpload(file);
                                            if (url) handleAdditionalDetailChange(si, di, 'image', url);
                                          }
                                        }}
                                      />
                                      <i className="fa fa-camera i-pic-upload"></i>
                                    </div>
                                  </div>
                                  {detail.image && <small>{detail.image}</small>}
                                  {detail.image && (
                                    <div className="image-preview">
                                      <img src={`${config.BASE_URL}${detail.image}`} alt="Additional detail" style={{ maxWidth: '200px' }} />
                                    </div>
                                  )}
                                </div>
                                <button type="button" onClick={() => removeAdditionalDetail(si, di)}>Remove Item</button>
                              </div>
                            </>
                          ))}
                          <button type="button" onClick={() => addAdditionalDetail(si)}>Add Item</button>
                        </div>
                        <button type="button" onClick={() => removeAdditionalSection(si)}>Remove Section</button>
                      </div>
                    </>
                  ))}
                  <button type="button" onClick={addAdditionalSection}>Add Section</button>
                </div>
              </div>
              <div className="form-login bg-gray-rounded">
                <div className="add_field titleField">
                  <h2>Booking Description</h2>
                  <input
                    type="text"
                    name="bookingDescription"
                    value={formData.bookingDescription}
                    onChange={(e) => handleInputChange(e.target)}
                  />
                </div>

                <div className="add_field titleField">
                  <h2>Booking Link</h2>
                  <input
                    type="text"
                    name="bookingLink"
                    value={formData.bookingLink}
                    onChange={(e) => handleInputChange(e.target)}
                  />
                </div>

                <div className="add_field titleField">
                  <h2>Booking Image</h2>
                  <div className="form-group">
                    <div className="file-upload">
                      <input
                        type="file"
                        className="form-control"
                        name="bookingInfoImage"
                        onChange={(e) => handleInputChange(e.target)}
                      />
                      <i className="fa fa-camera i-pic-upload"></i>
                    </div>
                  </div>
                  {bookingPreview && (
                    <div className="image-preview">
                      <img src={bookingPreview} alt="Booking preview" style={{ maxWidth: '200px' }} />
                    </div>
                  )}
                </div>

                <div className="add_field titleField">
                  {/* <label> */}
                  Set as Featured
                  <input
                    type="checkbox"
                    name="isFeatured"
                    checked={!!formData.isFeatured}
                    onChange={(e) => handleInputChange(e.target)}
                  />
                  {/* </label> */}
                </div>
              </div>
              <div className="add_project">
                <button
                  type="submit"
                  disabled={submitLoading}
                  style={{
                    opacity: submitLoading ? 0.6 : 1,
                    cursor: submitLoading ? 'not-allowed' : 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px'
                  }}
                >
                  {submitLoading && (
                    <div
                      style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid #ffffff',
                        borderTop: '2px solid transparent',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite'
                      }}
                    />
                  )}
                  {submitLoading ? 'Adding...' : 'Add Packege'}
                </button>
              </div>
            </form>
            {error && <p className="error-message">{error}</p>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddPackege;
